
import { ResultLevel } from "@/components/AnalysisResults";

/**
 * Determine result level for text analysis based on score
 * @param score Score from 0-100
 * @returns Result level (safe, suspicious, fraudulent)
 */
export function determineTextAnalysisLevel(score: number): ResultLevel {
  if (score >= 70) return "fraudulent";
  if (score >= 40) return "suspicious";
  return "safe";
}

/**
 * Determine result level for plagiarism checks based on score
 * @param score Score from 0-1
 * @returns Result level (safe, suspicious, fraudulent)
 */
export function determinePlagiarismLevel(score: number): ResultLevel {
  if (score >= 0.7) return "fraudulent";
  if (score >= 0.4) return "suspicious";
  return "safe";
}

/**
 * Map detection result flags to a result level
 * @param flags Array of flag strings
 * @param suspiciousFlags Array of flags that indicate suspicious content
 * @param fraudulentFlags Array of flags that indicate fraudulent content
 * @returns Result level
 */
export function determineLevelFromFlags(
  flags: string[],
  suspiciousFlags: string[] = [],
  fraudulentFlags: string[] = []
): ResultLevel {
  const hasFraudulentFlag = flags.some(flag => fraudulentFlags.includes(flag));
  if (hasFraudulentFlag) return "fraudulent";
  
  const hasSuspiciousFlag = flags.some(flag => suspiciousFlags.includes(flag));
  if (hasSuspiciousFlag) return "suspicious";
  
  return "safe";
}
